import React from 'react';
import { FiUsers as Users, FiHome as Building, FiUserCheck as UserCheck, FiFolder as FolderOpen, FiUser as User } from 'react-icons/fi';
import { IconType } from 'react-icons';

interface AdminTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

interface TabItem {
  id: string;
  label: string;
  icon: IconType;
}

export const AdminTabs: React.FC<AdminTabsProps> = ({ activeTab, setActiveTab }) => {
  const tabs: TabItem[] = [
    { id: 'partners', label: 'Partners', icon: Building },
    { id: 'clients', label: 'Clients', icon: Users },
    { id: 'aws-users', label: 'AWS Users', icon: UserCheck },
    { id: 'projects', label: 'Projects', icon: FolderOpen },
    { id: 'users', label: 'Users', icon: User }
  ];

  return (
    <div className="border-b border-gray-200 dark:border-gray-700">
      <nav className="-mb-px flex space-x-8">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition-colors ${
                activeTab === tab.id
                  ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                  : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
              }`}
            >
              <Icon className="w-4 h-4" />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default AdminTabs;
